import "./About.css";
const About = () => {
  return (
    <div id="about">
      <div id="main">
        <div className="heading">About</div>
        <p>
          Greetings!
          <br />
          Frontend-focused Full Stack Developer with 3+ years of experience
          building high-performance, scalable, and user-friendly web
          applications using React, Next.js, and Node.js.
          <br />
          Currently working at Mayhem Studios (MPL), where I’ve contributed to
          building data dashboards, CMS platforms, and internal tools used by
          cross-functional teams. I specialize in creating responsive UIs,
          integrating APIs, and embedding real-time data visualizations using
          tools like Grafana, Databricks, and Tableau.
          <br />
          I’m passionate about clean code, test-driven development (TDD), and
          improving developer experience. I enjoy solving real-world problems
          through thoughtful architecture, intuitive UX, and scalable backend
          logic. I’ve also worked with DevOps tools like Docker, Kubernetes,
          GCP, and CI/CD pipelines.
          <br />
          Whether it’s developing an analytics dashboard, automating internal
          workflows, or enhancing a user-facing web app — I focus on building
          solutions that are fast, reliable, and maintainable.
          <br />
          🚀 Tech Highlights: React.js | Next.js | Node.js | Express.js |
          MongoDB | PostgreSQL | Tailwind | Zustand | MUI | Firebase | GCP |
          Docker | CI/CD | OAuth2 | REST APIs | TDD
          <br />
          🎯 Let’s connect if you're hiring for full stack/product engineering
          roles, or if you want to chat about building intuitive web platforms
          from scratch.
        </p>
      </div>
    </div>
  );
};
export default About;
